


























































































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/marketing/live/index'
import { FormItem } from '../../types/iview/form'
@Component({
  components: {
    CustomForm,
  },
})
export default class CommissionList extends AbpBase {
  modal2: boolean = false
  modal3: boolean = false
  prevModal: boolean = false
  previewUrl: string = ''
  tabLoading: boolean = false
  isOpenLive: boolean = false
  selectLiveRoomObj: any = {}
  selectPushRoomObj: any = {}
  filters = [
    {
      label: '开始时间',
      type: 'date',
      props: {
        placeholder: '请选择开始日期',
      },
      key: 'startTime',
    },
    {
      label: '结束时间',
      type: 'date',
      props: {
        placeholder: '请选择结束日期',
      },
      key: 'endTime',
    },
    {
      label: '活动状态',
      type: 'select',
      props: {
        placeholder: '请选择状态',
      },
      key: 'status',
      options: [
        {
          value: 0,
          text: '未开始',
        },
        {
          value: 1,
          text: '进行中',
        },
        {
          value: 2,
          text: '已结束',
        },
      ],
    },
  ]
  filtersModal = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'name',
    },
  ]
  filtersModal2 = [
    {
      label: '商品名称：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'name',
    },
    {
      label: '商品代码：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'code',
    },
  ]
  columns = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '直播间名称',
      key: 'name',
      align: 'center',
      // width: 100,
    },
    {
      title: '背景图',
      slot: 'coverImg',
      align: 'center',
      // width: 100,
    },
    {
      title: '分享图',
      slot: 'shareImg',
      align: 'center',
      // width: 100,
    },
    {
      title: '直播间ID',
      key: 'roomId',
      align: 'center',
      //  width: 100,
    },
    {
      title: '状态',
      slot: 'liveStatus',
      align: 'center',
      // width: 200
    },
    {
      title: '开始时间',
      slot: 'startTime',
      align: 'center',
      // width: 140,
    },
    {
      title: '结束时间',
      slot: 'endTime',
      align: 'center',
      // width: 140,
    },
    {
      title: '主播',
      key: 'anchorName',
      align: 'center',
      //  width: 100,
    },
    // {
    //   title: '拉取房间总数',
    //   key: 'name',
    //   align: 'center',
    //   //  width: 100,
    // },
    {
      title: '操作',
      slot: 'action',
      width: 290,
      align: 'center',
    },
  ]
  goodsData: any[] = []
  pushData: any[] = []
  columnsShops: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '商品编码',
      key: 'code',
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '价格',
      key: 'price',
      align: 'center',
    },
    {
      title: '是否已推送',
      slot: 'isPush',
      align: 'center',
      // width: 100,
    },
    {
      title: '是否已上架',
      slot: 'onSale',
      align: 'center',
      // width: 100,
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  exporting: boolean = false
  copyData = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  pageShops = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  pagePush = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    // let startTime = form['startTime'] ? this.dateString(form['startTime']) : null
    // let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    this.tabLoading = true
    Api.getLiveRoomList(this.pager.pageSize, this.pager.pageIndex).then((res) => {
      this.tabLoading = false
      console.log('直播间列表', res)
      this.pager.total = res.data.totalCount
      this.copyData = res.data.items
    })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    // this.loadData((this.$refs.lineForm as any).form)
    this.loadData()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  statistics() {
    this.$router.push({
      name: 'liveStatisticalReport',
    })
  }
  getQrCode(row: any) {
    var roomId = row.roomId
    Api.getQrCode(roomId)
      .then((res) => {
        if (res.data.name == '1') {
          // this.$Modal.confirm({
          //   title: '二维码',
          //   content: '<img style="wdith:300px;" src="' + res.data.value + '">',
          // })
          this.previewUrl = res.data.value
          this.prevModal = true
          // var alink = document.createElement("a");
          // alink.href = res.data.value;
          // alink.download = "pic"; //图片名
          // alink.click();
        } else {
          this.$Notice.error({ desc: '当前状态不允许获取' })
        }
      })
      .catch((r) => { })
  }
  pushToWeixin(row: any) {
    this.tabLoading = true
    Api.liveRoomPushToWechat(row.id)
      .then((res) => {
        this.tabLoading = false
        this.$Notice.success({ desc: '推送成功' })
        this.loadData()
      })
      .catch((r) => {
        this.tabLoading = false
      })
  }
  deleteRoomProduct(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `确定删除吗?`,
      onOk: () => {
        Api.deleteRoomProduct(row.id).then((res) => {
          this.$Notice.success({ desc: '删除成功' })
          this.getPushRoomShops()
        })
      },
    })
  }
  deleteRow(row: any) {
    console.log(row)
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        Api.deleteLiveRoomInfoById(row.id).then((res) => {
          this.$Notice.success({ desc: '删除成功' })
          this.loadData()
        })
      },
    })
  }
  editLiveRoom(row: any) {
    console.log(row)
    this.$router.push({
      name: 'createdLiveRoom',
      query: {
        id: row.id,
      },
    })
  }
  relatedProduct(row: any) {
    console.log(row)
    this.getLiveRoomShops()
    this.modal2 = true
    this.selectLiveRoomObj = row
  }
  pushProduct(row: any) {
    console.log(row)
    this.selectPushRoomObj = row
    this.getPushRoomShops()
    this.modal3 = true
  }
  /**
   * 获取直播间商品
   */
  getLiveRoomShops(name?: string) {
    Api.getLiveRoomCommodityList(this.pageShops.maxResultCount, this.pageShops.currentPage, true, name, '2').then(
      (res) => {
        console.log('直播间商品', res)
        this.goodsData = res.data.items
        this.pageShops.totalCount = res.data.totalCount
      }
    )
  }

  getPushRoomShops(name?: string, code?: string) {
    Api.getPushRoomCommodityList(
      this.pageShops.maxResultCount,
      this.pageShops.currentPage,
      name,
      code,
      this.selectPushRoomObj.id
    ).then((res) => {
      console.log('推送商品', res)
      this.pushData = res.data.items
      this.pagePush.totalCount = res.data.totalCount
    })
  }
  createdLiveRoom() {
    this.$router.push({
      name: 'createdLiveRoom',
    })
  }
  updatedLiveRoom() {
    this.loadData()
  }
  configurationGuide() {
    // 配置指南
  }
  cancel() {
    this.modal2 = false
  }
  cancelPush() {
    this.modal3 = false
  }
  submitModalChange(form, valid) {
    if (valid) {
      console.log(form)
      this.getLiveRoomShops(form.name)
    }
  }
  selectGoods(row: any) {
    console.log(row)
    let data = {
      roomId: this.selectLiveRoomObj.id,
      wechatProductId: row.id,
      productId: row.productId,
      isPush: false,
    }
    let arr = []
    arr.push(data)
    Api.selectGoodsByRelated(arr).then((res) => {
      console.log('选取关联商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal2 = false
      this.loadData()
    })
  }
  selectGoodsList() {
    let selection = (this.$refs.selectiontab as any).getSelection()
    console.log(selection)
    if (selection.length == 0) {
      this.$Notice.error({ desc: '请选择商品' })
      return
    }
    var arr = []
    for (var i = 0; i < selection.length; i++) {
      var row = selection[i]

      let data = {
        roomId: this.selectLiveRoomObj.id,
        wechatProductId: row.id,
        productId: row.productId,
        isPush: false,
      }
      arr.push(data)
    }
    Api.selectGoodsByRelated(arr).then((res) => {
      console.log('选取关联商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal2 = false
      this.loadData()
    })
  }
  pushGoods(row: any) {
    console.log(row)
    // let data = {
    //   roomId: this.selectLiveRoomObj.id,
    //   wechatProductId: row.id,
    //   productId: row.productId,
    //   isPush: false,
    // }
    let arr = []
    arr.push(row.id)
    Api.pushGoods(this.selectPushRoomObj.id, arr).then((res) => {
      console.log('推送关联商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal3 = false
      this.loadData()
    })
  }
  onSaleGoodsList(value: number) {
    let selection = (this.$refs.selection as any).getSelection()
    console.log(selection)
    if (selection.length == 0) {
      this.$Notice.error({ desc: '请选择商品' })
      return
    }

    var nostatus = selection.find((x) => !x.isPush)
    console.log(nostatus)
    if (nostatus != undefined && JSON.stringify(nostatus) != '{}') {
      this.$Notice.error({ desc: nostatus.name + '还未推送' })
      return
    }

    var arr = []
    for (var i = 0; i < selection.length; i++) {
      var row = selection[i]
      arr.push(row.wechatProductId)
    }
    Api.onSaleGoods(arr, this.selectPushRoomObj.id, value).then((res) => {
      this.$Notice.success({ desc: '操作成功' })
      this.modal3 = false
      this.loadData()
    })
  }
  pushGoodsList() {
    let selection = (this.$refs.selection as any).getSelection()
    console.log(selection)
    if (selection.length == 0) {
      this.$Notice.error({ desc: '请选择商品' })
      return
    }
    var arr = []
    for (var i = 0; i < selection.length; i++) {
      var row = selection[i]

      arr.push(row.id)
    }
    Api.pushGoods(this.selectPushRoomObj.id, arr).then((res) => {
      console.log('推送关联商品', res)
      this.$Notice.success({ desc: '添加成功' })
      this.modal3 = false
      this.loadData()
    })
  }
  onPageShopsChange(pageIndex) {
    this.pageShops.currentPage = pageIndex
    this.submitModalChange(this.$refs['lineModalForm'], true)
  }

  onPagePushChange(pageIndex) {
    this.pagePush.currentPage = pageIndex
    this.submitModalChange(this.$refs['pushModalForm'], true)
  }
  /**
   * 导出excel表格
   */
  // exportExcel() {
  //   this.exporting = true
  //   let refForm: any = this.$refs.lineForm
  //   const form = refForm.getForm()
  //   console.log(form)
  //   let startTime = form['startTime']
  //   let endTime = form['endTime']
  //   Api.exportWidthdrawReportFile(this.pager.pageSize, this.pager.pageIndex, startTime, endTime)
  //     .then((res) => {
  //       console.log(res)
  //       this.exporting = false
  //       this.download(res.data)
  //     })
  //     .catch((err) => {
  //       this.exporting = false
  //     })
  // }
  // download(data) {
  //   if (!data) {
  //     return
  //   }
  //   let url = window.URL.createObjectURL(new Blob([data]))
  //   let link = document.createElement('a')
  //   link.style.display = 'none'
  //   link.href = url
  //   link.setAttribute('download', '提佣统计表.xlsx')

  //   document.body.appendChild(link)
  //   link.click()
  // }
}
